import Button, { ButtonProps } from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { maxWidth } from "@mui/system";
import { theme as _theme } from "../../helpers/theme";

export const StyledOutlinedButton = styled(Button)<ButtonProps>(
  ({ theme }) => ({
    height: `${_theme.buttonSize.projFormH}`,
    color: "black",
    border: "1px solid black",
    borderRadius: `${_theme.radius.thirdRadius}`,

    fontWeight: `${_theme.fontWeight.normal}`,
    fontFamily: `${_theme.fonts.interMedium}`,
    textTransform: "none",
    fontSize: "14px",

    // ":disabled": {
    //   backgroundColor: `${_theme.colors.blue03_discabled}`,
    //   color: `${_theme.colors.white}`,
    // },
    "&:hover": {
      backgroundColor: `${_theme.colors.gray04_background}`,
      border: `1px solid ${_theme.colors.blue02_hover}`,
      color: `${_theme.colors.blue02_hover}`,
    },
  })
);
